import React, {Component} from "react";
import {
    FormGroup,
    ControlLabel,
    FormControl,
    Row,
    Col
}                         from "react-bootstrap";
import Select             from "react-select";
import                         "react-select/dist/react-select.css";

import {
  IS_VALID
}                         from "utils";

import Loader             from "../../Loader";

class Create extends Component {
    render () {
        let {
            Beacon,
            actions
        } = this.props;

        let {
            isLoadingAction,

            uuid,
            major,
            minor,
            hexNamespace,
            hexInstance
        } = Beacon;

        let requiredSpan = <span style={{ color: "red" }}>*</span>;

        return (
            <form>
                <Loader loading={isLoadingAction}/>
                <FormGroup>
                    <ControlLabel>UUID {requiredSpan}</ControlLabel>
                    <FormControl
                        type="text"
                        placeholder="Enter UUID..."
                        value={uuid}
                        onChange={(e) => {
                            actions.setValue({
                                uuid: e.target.value
                            });
                        }}
                    />
                </FormGroup>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel>Major {requiredSpan}</ControlLabel>
                            <FormControl
                                type="number"
                                placeholder="Enter Major..."
                                value={major}
                                onChange={(e) => {
                                    actions.setValue({
                                        major: e.target.value
                                    });
                                }}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel>Minor {requiredSpan}</ControlLabel>
                            <FormControl
                                type="number"
                                placeholder="Enter Minor..."
                                value={minor}
                                onChange={(e) => {
                                    actions.setValue({
                                        minor: e.target.value
                                    });
                                }}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel>Hex Namespace {requiredSpan}</ControlLabel>
                            <FormControl
                                type="text"
                                placeholder="Enter Hex Namespace..."
                                value={hexNamespace}
                                onChange={(e) => {
                                    actions.setValue({
                                        hexNamespace: e.target.value
                                    });
                                }}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <ControlLabel>Hex Instance {requiredSpan}</ControlLabel>
                            <FormControl
                                type="text"
                                placeholder="Enter Hex Instance..."
                                value={hexInstance}
                                onChange={(e) => {
                                    actions.setValue({
                                        hexInstance: e.target.value
                                    });
                                }}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </form>
        );
    }
}

import {connect} from "react-redux";

function mapStateToProps(state) {
	let {
        Beacon
	} = state;

	return {
        Beacon
	};
}

export default connect(mapStateToProps)(Create);


// WEBPACK FOOTER //
// ./components/Beacon/FormContainer/Create.js